function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5414 14.5523H15.3451C15.5778 14.5487 15.7945 14.6696 15.9119 14.8687C16.0294 15.0678 16.0294 15.3141 15.9119 15.5132C15.7945 15.7123 15.5778 15.8333 15.3451 15.8296H0.654931C0.422183 15.8333 0.205529 15.7123 0.0880837 15.5132C-0.0293612 15.3141 -0.0293612 15.0678 0.0880837 14.8687C0.205529 14.6696 0.422183 14.5487 0.654931 14.5523H2.45936V11.3109C2.45971 10.9586 2.7477 10.6729 3.10334 10.6721H3.92757V7.91513C3.92793 7.56251 4.2164 7.27673 4.57235 7.27638H5.39659V5.48962C5.39703 5.13705 5.68547 4.85138 6.04137 4.85103H6.37598V2.57907C6.37634 2.22653 6.66474 1.94082 7.0206 1.94047H7.35522V0.638751C7.35522 0.285979 7.6439 0 8 0C8.3561 0 8.64478 0.285979 8.64478 0.638751V1.94047H8.97908C9.3351 1.94065 9.62374 2.22638 9.62418 2.57907V4.85103H9.95879C10.3146 4.85146 10.603 5.13712 10.6034 5.48962V8.73166H11.4278C11.7837 8.73209 12.0721 9.01784 12.0724 9.37041V12.6124H12.8968C13.2527 12.6129 13.5411 12.8986 13.5414 13.2512V14.5523ZM5.21687 8.55373V10.6908C5.50436 10.7617 5.70624 11.0174 5.70648 11.3109V14.5523H6.37587V8.55373H5.21687ZM7.66596 4.85085V3.21764H8.33519V4.85085H7.66596ZM10.2931 13.2511C10.2934 12.9577 10.4953 12.7021 10.7827 12.631V10.0089H9.62368V14.5522H10.2931V13.2511Z",
  fill: "#37517F"
});

const SvgSkyscrapperFilled = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSkyscrapperFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Skyscrapper-Filled.89d73c12.svg";
export { ForwardRef as ReactComponent };